import React from "react";
import "./Personnel_Details.css"
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Personnel_Details_Form from "./personnel_Details_Form/Personnel_Details_Form";
import Personnel_Details_table from "./personnel_Details_table/Personnel_Details_table";
import { Tab, Tabs } from "react-bootstrap";
import Raised_Training_table from "./raised_Training_table/Raised_Training_table";

function Personnel_Details() {
  return (
    <>
      <section className="Imperiality ">
        <div className="back_div">
          <Common_Back_Btn backText="Personal Details" />
        </div>

        <div className="imperiality_Form_div">
          <Personnel_Details_Form />
        </div>

        <Tabs
          defaultActiveKey="Personnel_Details"
          id="uncontrolled-tab-example"
          className="gray_tabs_hodler mb-3"
        >
          <Tab eventKey="Personnel_Details" title="Personnel Details">
            <div className="imperiality_table_div">
              <Personnel_Details_table />
            </div>
          </Tab>
          <Tab
            eventKey="Raised_Training_Request"
            title="Raised Training Request"
          >
            <div className="imperiality_table_div">
              <Raised_Training_table />
            </div>
          </Tab>
        </Tabs>
      </section>
    </>
  );
}

export default Personnel_Details;
